import { Dispatch } from 'redux'
import {
  add as addAction,
  deleteNews as deleteNewsAction,
  set as setAction,
  setLoading,
  update as updateAction
} from 'states/dux/nivos-news/actions'
import { Payload } from 'states/dux/nivos-news/types'
import { Action } from 'states/types'
import { NivosNews } from 'types/nivos-news'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (news: NivosNews[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: news
      })
    )
}

const update = (news: NivosNews): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [news]
      })
    )
}

const add = (news: NivosNews): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [news]
      })
    )
}

const deleteNews = (news: NivosNews): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      deleteNewsAction({
        loading: false,
        data: [news]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

export interface Operations {
  set: (news: NivosNews[]) => DispatchAction
  add: (news: NivosNews) => DispatchAction
  deleteNews: (news: NivosNews) => DispatchAction
  update: (news: NivosNews) => DispatchAction
  loading: (loading: boolean) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  deleteNews,
  update,
  loading
}

export { operations, set }
